import { Flex, styled } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';

const styles = {
  SkeletonWrapper: styled(Flex, {
    alignItems: 'center',
    gap: '$4',
    marginTop: '$6',
    padding: '$0',
  }),

  SectionWrapper: styled('div', {}),

  SubTitle: styled(ResponsiveFloraTypography, {
    color: '$nonInteractivePredominant',
  }),

  SubText: styled(ResponsiveFloraTypography, {
    color: '$nonInteractiveAuxiliar',
  }),

  InfoWrapper: styled(Flex, {
    gap: '$2',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '@desktop': {
      justifyContent: 'start',
    },
  }),
};

export default styles;
